export default "__VITE_ASSET__BMK_yjLB__"